const MAX_X_ANGLE_DEG = 10;
const MAX_Y_ANGLE_DEG = 10;
const CONTAINER_SELECTOR = '[data-rotate-element-by-hover-container]';
const ELEMENT_DATA_ATTRIBUTE = 'data-rotate-element-by-hover';
const ELEMENT_SELECTOR = `[${ELEMENT_DATA_ATTRIBUTE}]`;

initRotateElementByHover();

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        initRotateElementByHover();
      }
  });
});

const containers = document.querySelectorAll(CONTAINER_SELECTOR);
containers.forEach(container => observer.observe(container, { childList: true, subtree: true }));

function initRotateElementByHover() {
  const rotatingElements = document.querySelectorAll(`${ELEMENT_SELECTOR}:not([${ELEMENT_DATA_ATTRIBUTE}="inited"])`);

  rotatingElements.forEach(element => {
    element.style.transition = "transform 100ms";
    element.style.transformStyle = "preserve-3d";
    element.style.perspective = "1000px";
    element.setAttribute(ELEMENT_DATA_ATTRIBUTE, 'inited');

    element.addEventListener('mousemove', getHoverHandler(element));
  })
}

function getHoverHandler(element) {
  return (e) => {
    const rect = element.getBoundingClientRect();
    
    // Calculate relative coordinates
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Calculate percentages from the center of the element
    const xPercent = x / rect.width - 0.5;
    const yPercent = y / rect.height - 0.5;

    // for calculate rotating around X axis we use Y coord and vice versa
    requestAnimationFrame(() => {
      element.style.transform = `rotateX(${-1 * (yPercent * MAX_Y_ANGLE_DEG).toFixed(2)}deg) rotateY(${(xPercent * MAX_X_ANGLE_DEG).toFixed(2)}deg)`
    });
  }
}

function getMouseLeaveHandler(element) {
  return () => {
    element.style.transform = '';
  }
}